import React, { useEffect, useRef, useState } from 'react'
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Header from '../components/Header'
import Home from '../components/Home';
import Project from '../components/Project';
import Services from '../components/Services';
import Skills from '../components/Skills';
import Testimonials from '../components/Testimonials';



function LandingPage() {
    const menuref = useRef(null);
    const scrollref = useRef(null);

    const scrollUp = (e) => {
        const scrollY = window.pageYOffset;
        const scrollup = scrollref.current;
        scrollY >= 350 ? scrollup.classList.add('show-scroll') : scrollup.classList.remove('show-scroll');
    }



    useEffect(() => {

        window.addEventListener('scroll', scrollUp);
    }, [scrollUp]);
    return (
        <>
            <Header menuref={menuref} />
            <div className='main'>
                <Home menuref={menuref} />
                <Skills menuref={menuref} />
                <Services menuref={menuref} />
                <Project menuref={menuref} />
                <Testimonials menuref={menuref} />
                <Contact menuref={menuref} />
                <Footer />
                <a href="#" className="scrollup" id="scroll-up" ref={scrollref}>
                    <i className="ri-arrow-up-line"></i>
                </a>
            </div>

        </>
    )
}

export default LandingPage